export const ENERGY_MAX = 100;
export const HAPPINESS_MAX = 100;
export const HUNGER_MAX = 100;

export const HAPPINESS_DECAY_PER_HOUR = 0.75;

export const EDUCATION_LEVEL_BASE_XP = 100;
export const EDUCATION_LEVEL_FACTOR = 2;
export const EDUCATION_MAX_LEVEL = 5;

export type EducationLevel = 0 | 1 | 2 | 3 | 4 | 5;

export type Stats = {
  readonly money: number;
  readonly energy: number;
  readonly happiness: number;
  readonly hunger: number;
  readonly education: number;
  readonly foodAtHome: number;
};

function clamp(v: number, lo: number, hi: number): number {
  return Math.min(hi, Math.max(lo, v));
}

export function createStats(init: Partial<Stats> = {}): Stats {
  return Object.freeze({
    money: Math.trunc(init.money ?? 50_000),
    energy: clamp(init.energy ?? 80, 0, ENERGY_MAX),
    happiness: clamp(init.happiness ?? 60, 0, HAPPINESS_MAX),
    hunger: clamp(init.hunger ?? 70, 0, HUNGER_MAX),
    education: Math.max(0, Math.trunc(init.education ?? 300)),
    foodAtHome: Math.max(0, Math.trunc(init.foodAtHome ?? 5)),
  });
}

export function educationLevel(xp: number): EducationLevel {
  if (xp < EDUCATION_LEVEL_BASE_XP) return 0;
  const raw = Math.floor(Math.log2(xp / EDUCATION_LEVEL_BASE_XP + 1));
  return clamp(raw, 0, EDUCATION_MAX_LEVEL) as EducationLevel;
}

export function xpForLevel(level: EducationLevel): number {
  return EDUCATION_LEVEL_BASE_XP * (EDUCATION_LEVEL_FACTOR ** level - 1);
}

export function isAlive(stats: Stats): boolean {
  return stats.energy > 0 && stats.happiness > 0 && stats.hunger > 0;
}
